import { render, staticRenderFns } from "./war.vue?vue&type=template&id=033f1ca6&"
import script from "./war.vue?vue&type=script&lang=js&"
export * from "./war.vue?vue&type=script&lang=js&"
import style0 from "./war.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports